import React, { useMemo } from "react";
import random from "lodash/random";
import { cellGrow } from "constants/styles";
import ClickWrapper from "components/ClickWrapper";
import { DIMENSIONS } from "utils/constants/image";
import Image from "components/Image";
import { PRIORITY_FILL } from "utils/constants/ui";
import classnames from "classnames";

const ProductCell = ({ model, isFirst, isLast, isActive, onClick }) => {
  const randomIndex = useMemo(() => random(0, 9), []);
  const { id, name, description, image, priceRange } = model;

  return (
    <div
      className={classnames(
        "cell__product shadow-0 ba br2 bg-white w-100 relative cell-grow",
        {
          "hairline-1": !isActive,
          "ba--primary": isActive
        }
      )}
    >
      <div className="flex flex-column justify-between">
        <ClickWrapper id={id} onClick={onClick}>
          <div className="pv2 flex flex-column justify-between pointer">
            <div className="flex flex-row justify-between ph2">
              <div className="f4 pb2 fw6 lh-title word-break truncate">
                {name}
              </div>
            </div>
            <div
              style={{ height: DIMENSIONS.PRODUCT_CELL.height }}
              className="flex flex-row pointer w-100 overflow-hidden relative bt hairline-1"
            >
              {image ? (
                <Image src={image} alt={name} {...PRIORITY_FILL} />
              ) : (
                <Image
                  src={`/assets/bg__cloudMask_${randomIndex}.png`}
                  alt={name}
                  {...PRIORITY_FILL}
                />
              )}
            </div>
            {description && (
              <div className="f7 pa2 lh-copy word-break bt hairline-1">
                {description}
              </div>
            )}
          </div>
        </ClickWrapper>
        <div style={{ height: 33 }} className="w-100"></div>
        <div className="absolute bottom-0 right-0 left-0 z-1 center flex flex-row justify-end items-center w-100 bt hairline-1 pa2 bg-white f6">
          {priceRange && (
            <div className="f4 fw6 flex-shrink-0">{priceRange}</div>
          )}
        </div>
      </div>
      <style jsx>{cellGrow}</style>
    </div>
  );
};

export default ProductCell;
